import { onMounted, ref } from "vue";
import { BeforeAfter } from '@/jsUtils/picture_beforeafter.js';
export default {
  data() {
    return {
      // before: require('@/assets/maindetail/compare/memory_0.png'),
      // after: require('@/assets/maindetail/compare/memory_1.png'),
      beforeAfterInstance: null,
      imagesLoaded: 0,
      // 追踪已加载的图片数量
      pluginKey: 0 // 用于强制重渲染的 key
    };
  },

  mounted() {
    window.addEventListener('resize', this.handleResize);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.handleResize);
    this.cleanupBeforeAfter(); // 清理插件实例以避免内存泄漏
  },

  // before图像和after图像由父组件输入
  props: {
    before: {
      type: String,
      default: require('@/assets/maindetail/compare/memory_0.png')
    },
    after: {
      type: String,
      default: require('@/assets/maindetail/compare/memory_1.png')
    }
  },
  activated() {
    this.initializeBeforeAfter();
  },
  deactivated() {
    this.cleanupBeforeAfter(); // 清理插件实例以避免内存泄漏
  },

  methods: {
    onImageLoad() {
      this.imagesLoaded += 1;
      // 当所有图片加载完成后初始化插件
      if (this.imagesLoaded === 2) {
        this.initializeBeforeAfter();
      }
    },
    initializeBeforeAfter() {
      const container = this.$refs.beforeAfterContainer;
      if (!container) {
        return;
      }
      if (this.beforeAfterInstance) {
        this.beforeAfterInstance.destroy(); // 假设插件有销毁方法
      }
      // 强制重渲染容器以确保初始化正确
      this.pluginKey += 1;
      if (this.pluginKey > 99999999) {
        this.pluginKey = 0;
      }
      this.$nextTick(() => {
        // 确保容器仍然存在
        if (this.$refs.beforeAfterContainer) {
          this.beforeAfterInstance = new BeforeAfter({
            id: `#beforeAfter-${this.pluginKey}`
          });
        }
      });
    },
    handleResize() {
      this.initializeBeforeAfter();
    },
    cleanupBeforeAfter() {
      if (this.beforeAfterInstance) {
        this.beforeAfterInstance.destroy();
        this.beforeAfterInstance = null;
      }
    }
  }
};

// onMounted(()=>{
// new BeforeAfter({
//     id: "#one",
// });
// })